<script>

    import { createEventDispatcher} from 'svelte'
    import { toast } from 'bulma-toast'

    import UsersService from "../$services/users.service"

    export let user = null
    export let userId = null
    export let required = true
    export let role = null
    export let label = 'Usuario'
    export let hideLabel = false
    export let value = null

    const dispatch = createEventDispatcher()

    let loading = false
    let showItems = false
    let users = []
    let lastValue = value

    async function getUsersFind() {

        // Tab y otras teclas que no cambian el texto no deben borrar la selección
        if(value === lastValue)
            return

        lastValue = value
        user = null
        userId = null
        showItems = false

        if(value === '')
            return dispatch('select', null)

        if(value.length < 2)
            return

        loading = true
        const resp = await UsersService.getUsersFind({value, role})
        loading = false

        if(!resp.success)
            return toast({ message: resp.error.message, type: "is-danger" })

        users = resp.data

        if(!resp.data.length)
            return

        showItems = true
    }

    function setUser(item) {
        user = item
        userId = item._id
        value = item.email
        lastValue = value
        showItems = false
        dispatch('select', {user, userId})
    }

</script>

<div class="field app-select-field">
    {#if !hideLabel}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <div class="dropdown app-select-users-dropdown" class:is-active={showItems}>
            <div class="dropdown-trigger">
                <input
                    class="input"
                    type="text"
                    bind:value={value}
                    on:keyup={getUsersFind}
                    placeholder="Buscar"
                    {required}
                />
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
                <div class="dropdown-content">
                    {#each users as user}
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a on:click={() => setUser(user)} class="dropdown-item">{ user.name } {user.email}</a>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .app-select-field {
        width: 100%;
        min-width: 0;
    }

    .app-select-field .control {
        width: 100%;
    }

    .app-select-users-dropdown {
        width: 100%;
    }

    .app-select-users-dropdown .dropdown-trigger {
        width: 100%;
    }

    .app-select-users-dropdown .dropdown-trigger .input {
        width: 100%;
    }

    .app-select-users-dropdown .dropdown-menu {
        width: 100%;
    }
</style>